/**
 * Origin the widget bundle was served from (e.g. https://widget-seguros-digitales.vercel.app).
 * Captured while the IIFE executes, when `document.currentScript` still points to it.
 * Empty in dev (ES modules) or when the bundle is inlined — callers fall back to same-origin.
 */
function detectScriptOrigin(): string {
  if (typeof document === 'undefined') return ''
  const script = document.currentScript
  if (!(script instanceof HTMLScriptElement) || !script.src) return ''
  try {
    return new URL(script.src).origin
  } catch {
    return ''
  }
}

export const WIDGET_SCRIPT_ORIGIN = detectScriptOrigin()
